import React from "react";
import DoneTwoTone from "@mui/icons-material/DoneTwoTone";
import { ConsultaContext } from "../Context";
import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

export default function PaymentSuccess() {
  const { paymentStatus } = React.useContext(ConsultaContext);

  if (paymentStatus.status !== "success") return null;

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        py={4}
      >
        <DoneTwoTone color="secondary" style={{ fontSize: 40 }} />
        <Typography variant="h6">Pago Realizado</Typography>
        <Typography align="center">{paymentStatus.data.message}</Typography>
        <Box my={1} />
        <Typography>
          <b>{`ID de pago: ${paymentStatus.data.idPago}`}</b>
        </Typography>
        <Typography>
          <b>{`ID Google Meet: ${paymentStatus.data.conferenceData?.idGoogleMeet}`}</b>
        </Typography>
        <Typography>
          <b>{`Enlace Google Meet: ${paymentStatus.data.conferenceData?.linkMeeting}`}</b>
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="secondary"
        disableElevation
        fullWidth
        component={Link}
        to="/"
      >
        Regresar a inicio
      </Button>
    </Box>
  );
}
